import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 3.75L14.47 8.96L20.2 9.7L16 13.65L17.07 19.32L12 16.55L6.93 19.32L8 13.65L3.8 9.7L9.53 8.96L12 3.75Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgStarFilled;
